const variantData = window.VARIANT_DATA;

export function ProductVariantForm(form) {
	if (!form) {
		return;
	}

	let variantInputs = Array.from(form.querySelectorAll('.js-product-form-variant-input'));

	variantInputs.forEach(element => element.addEventListener('input', onChange));

	function onChange(event) {
		let requireMatchAll = true;

		// The changed variant field.
		let inputName = event.target.name;
		let inputValue = getInputValue(inputName, form);

		// All the variant fields.
		let inputNames = getInputNames(variantInputs);
		let inputValues = getInputValues(inputNames, form);

		let filters = requireMatchAll ? inputValues : {
			[inputName]: inputValue,
		};

		let matchingVariants = filterArray(variantData, filters);

		let options = {};

		matchingVariants.forEach(variant => {
			inputNames.forEach(function(name) {
				let v = options[name] || (options[name] = []);

				if (!v.includes(variant[name])) {
					v.push(variant[name]);
				}
			});
		});

		let variantEvent = new CustomEvent('variantChange', {
			detail: matchingVariants,
		});

		form.dispatchEvent(variantEvent);
	}

	function on(name, handler) {
		form.addEventListener(name, handler);
	}

	return { on };
}


function getInputValues(names, form) {
	let values = {};

	names.forEach(name => {
		values[name] = getInputValue(name, form);
	});

	return values;
}

function getInputValue(name, form) {
	console.log(form, name);
	let field = form.elements[name];

	if (field instanceof HTMLSelectElement) {
		return field.value;
	}

	if (field instanceof RadioNodeList) {
		return getRadioNodeListValue(name, form);
	}

	if (field instanceof HTMLInputElement) {
		return field.value;
	}
}

function getRadioNodeListValue(name, form) {
	let fields = Array.from(form.querySelectorAll(`input[name=${name}]`));

	let values = fields.filter(e => e.checked).map(e => e.value);

	if (values.length <= 1) {
		return values[0];
	}

	return values;
}

function getInputNames(elements) {
	let names = elements.map(e => e.name);
	let uniqueNames = Array.from(new Set(names));

	return uniqueNames;
}

function filterArray(array, filters) {
	return array.filter(function(item) {
		for (let key in filters) {
			if (filters[key] != false && item[key] != filters[key]) {
				return false;
			}
		}

		return true;
	});
}
